import { FALLBACK_RETURN_LABEL_FORM_URL } from 'Modals/CreateReturnLabelModal/CreateReturnLabelModal.constants'

import type { getEmployee_employee_organisation } from 'Constants/graphql/queries/employee/__generated__/getEmployee'
import type { getOrganisation_organisation } from 'Constants/graphql/queries/organisation/__generated__/getOrganisation'

const replaceUrlPlaceholders = (
  url: string,
  orgId: string,
  returnCaseId: string,
  serialNumber: string,
  imei: string,
) =>
  url
    .replaceAll('{{ORGANISATION_ID}}', orgId)
    .replaceAll('{{RETURN_CASE_ID}}', returnCaseId)
    .replaceAll('{{SERIAL_NUMBER}}', serialNumber)
    .replaceAll('{{IMEI}}', imei)
    .replaceAll('{{IMEI_OR_SERIAL}}', imei || serialNumber)

export const getReturnLabelURL = (
  orgId: string | undefined,
  returnCaseId: string,
  country: string | undefined,
  serialNumber: string | null | undefined,
  imei: string | null | undefined,
  fulfillmentProviderMapping:
    | getEmployee_employee_organisation['fulfillmentProviderMapping']
    | getOrganisation_organisation['fulfillmentProviderMapping'],
) => {
  if (!orgId || !country) {
    return undefined
  }

  const fulfillmentProviderUrl = fulfillmentProviderMapping?.find(
    fulfillmentProviderData => fulfillmentProviderData.country === country,
  )?.fullUrl

  // Fall back to the generic everphone form when the org has no dedicated
  // provider URL for this country, so every supported country resolves to a
  // usable link instead of an empty URL.
  return replaceUrlPlaceholders(
    fulfillmentProviderUrl || FALLBACK_RETURN_LABEL_FORM_URL,
    orgId,
    returnCaseId,
    serialNumber ?? '',
    imei ?? '',
  )
}
